import { createApi } from '@reduxjs/toolkit/query/react';
import apiClient from '../../helpers/apiClient';

export const clientSchemaApi = createApi({
  reducerPath: 'clientSchemaApi',
  baseQuery: async ({ url, method = 'GET', data }) => {
    try {
      const response = await apiClient({
        method,
        url,
        data
      });
      return { data: response.data };
    } catch (error) {
      return {
        error: {
          status: error.response?.status,
          data: error.response?.data || error.message
        }
      };
    }
  },
  endpoints: (builder) => ({
    getClientSchemaDefaults: builder.query({
      query: () => ({
        url: '/v1/client-schema-defaults',
        method: 'GET'
      }),
      // Template defaults rarely change, cache for 15 minutes
      keepUnusedDataFor: 900
    }),
  }),
});

export const { useGetClientSchemaDefaultsQuery } = clientSchemaApi;